import { ChevronRight } from "lucide-react";
import type { SyllogismV2 } from "@/lib/api";

interface SyllogismDisplayProps {
  syllogism: SyllogismV2;
}

const SECTIONS: Array<{
  key: keyof SyllogismV2;
  label: string;
  color: string;
}> = [
  { key: "major", label: "MAJEURE", color: "var(--ai-violet)" },
  { key: "minor", label: "MINEURE", color: "var(--proof-gold)" },
  { key: "conclusion", label: "CONCLUSION", color: "var(--block-green)" },
];

/**
 * Affichage canonique du syllogisme juridique imposé (CdC #1).
 *
 * Trois sections colorées pour rendre visuellement la structure
 * MAJEURE / MINEURE / CONCLUSION. Pas d'animation : la lisibilité prime
 * pour les usages probatoires (capture d'écran possible).
 */
export function SyllogismDisplay({ syllogism }: SyllogismDisplayProps) {
  return (
    <div
      className="rounded-lg border p-4 space-y-3"
      style={{
        borderColor: "var(--graphite-600)",
        background: "var(--graphite-700)",
      }}
      aria-label="Réponse structurée en syllogisme juridique"
    >
      {SECTIONS.map(({ key, label, color }) => (
        <div key={key} className="flex gap-2">
          <div
            className="flex items-center gap-1 shrink-0 text-caption-arbitre"
            style={{ color }}
          >
            <ChevronRight size={11} />
            <span className="font-mono text-[10px] tracking-wider">{label}</span>
          </div>
          <p
            className="text-sm flex-1"
            style={{
              color: "var(--arbitre-slate-100)",
              lineHeight: 1.6,
            }}
          >
            {syllogism[key]}
          </p>
        </div>
      ))}
    </div>
  );
}
